import * as React from "react";

interface SubProps {
    children: React.ReactNode;
}

export class Sub extends React.Component<SubProps> {
    public render(): JSX.Element {
        return <sub>{this.props.children}</sub>;
    }
}
